export default () => {
  return {
    fetching: false,
    sso : {
      enabled: false,
      url: null
    }
  }
}
